import * as React from 'react'
import Progress from 'components/ui/progress-bar'
/**
 * TracksMeter component for displaying track usage progress
 *
 * A functional component that shows track usage as a progress bar with color-coded
 * status indicators. Gray for empty/zero usage, default color for normal usage,
 * and red for over-quota usage.
 *
 * @param props - Component props
 * @param props.current - Current number of tracks used
 * @param props.max - Maximum number of tracks allowed
 * @returns JSX element containing the progress bar meter
 */
export const TracksMeter = ({
  current,
  max,
}: {
  current: number
  max: number
}): React.ReactNode => {
  const progressValue = (current / max) * 100
  let value = progressValue
  let color: React.ComponentProps<typeof Progress>['color'] = undefined

  if (
    isNaN(progressValue) ||
    progressValue == null ||
    progressValue == undefined ||
    progressValue == 0 ||
    progressValue === Infinity
  ) {
    value = 100
    color = 'gray'
  } else if (progressValue >= 100) {
    value = 100
    color = 'red'
  }

  return <Progress value={value} color={color} />
}
